import React from 'react'
import * as ReactBootstrap from 'react-bootstrap'
import { InwardCommunication } from './InwardCommunication'
import { StatusCommunication } from './StatusCommunication'
import { DeliveryCommunication } from './DeliveryCommunication'
import {SendGridWebHookViewer} from "../../../components/SendGridWebHookViwer/SendGridWebHookViewer";
import {SendEstimationsByEmail} from "./SendStatusUpdateByEmail";

const Communication = ({ ticket }) => {
  return (
    <ReactBootstrap.Row block>
      <ReactBootstrap.Col xs={12}>
        <ReactBootstrap.Card>
          <ReactBootstrap.Card.Body
            style={{
              textAlign: 'center',
            }}
          >
            <InwardCommunication ticket={ticket} />
          </ReactBootstrap.Card.Body>
        </ReactBootstrap.Card>
      </ReactBootstrap.Col>
      <ReactBootstrap.Col xs={12}>
        <ReactBootstrap.Card>
          <ReactBootstrap.Card.Body
            style={{
              textAlign: 'center',
            }}
          >
            <StatusCommunication ticket={ticket} />
          </ReactBootstrap.Card.Body>
        </ReactBootstrap.Card>
      </ReactBootstrap.Col>
      <ReactBootstrap.Col xs={12}>
        <ReactBootstrap.Card>
          <ReactBootstrap.Card.Body
            style={{
              textAlign: 'center',
            }}
          >
            <DeliveryCommunication ticket={ticket} />
          </ReactBootstrap.Card.Body>
        </ReactBootstrap.Card>

          <ReactBootstrap.Card>
          <ReactBootstrap.Card.Body
            style={{
              textAlign: 'center',
            }}
          >
            <SendEstimationsByEmail ticket={ticket} />
          </ReactBootstrap.Card.Body>
        </ReactBootstrap.Card>


      </ReactBootstrap.Col>
        <ReactBootstrap.Col xs={12}>
        <ReactBootstrap.Card>
          <ReactBootstrap.Card.Body
            style={{
              textAlign: 'center',
            }}

          >
            <SendGridWebHookViewer email={ticket.email} />
          </ReactBootstrap.Card.Body>
        </ReactBootstrap.Card>
      </ReactBootstrap.Col>
    </ReactBootstrap.Row>
  )
}

export default Communication
